function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "\\uB808\\uC774\\uC5B4_2",
  "data-name": "\\uB808\\uC774\\uC5B4 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "\\uB808\\uC774\\uC5B4_1-2",
  "data-name": "\\uB808\\uC774\\uC5B4 1"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "37.92 12.7 37.92 8.82 23.44 0 7.98 8.8 37.85 28.5 37.92 28.38 37.92 24.58 20.54 13.11 23.22 11.54 37.92 20.75 37.92 16.84 23.27 7.66 17.45 11.08 14.31 9.01 23.38 3.84 37.92 12.7"
}), /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "7.56 11.56 7.56 15.36 24.95 26.82 22.27 28.4 7.56 19.19 7.56 23.1 22.22 32.28 28.03 28.85 31.18 30.93 22.1 36.09 7.56 27.24 7.56 31.12 22.05 39.93 37.51 31.13 7.64 11.44 7.56 11.56"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M10.18,51.39H6.11v2.26H4.06V51.39H0V49.55H10.18Zm-7.3-3.16a6,6,0,0,1-2.64.57V46.93a4,4,0,0,0,1.89-.48,4.22,4.22,0,0,0,1.53-1.32,4.25,4.25,0,0,0,.77-1.93l2,.3A6.1,6.1,0,0,1,6,45.1l4.16,2-.93,1.67L5,46.61A6.36,6.36,0,0,1,2.88,48.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M21.86,49.14H11.69V47.61H21.86Zm-1.71.91a1.54,1.54,0,0,1,0,3,9.51,9.51,0,0,1-3.37.47,9.54,9.54,0,0,1-3.38-.47,1.54,1.54,0,0,1,0-3,9.54,9.54,0,0,1,3.38-.47A9.51,9.51,0,0,1,20.15,50.05Zm-5.86-4.53h7.08V47H12.3V43.3h2ZM15,51.18c-.44.08-.66.2-.66.38s.83.49,2.48.49,2.47-.16,2.47-.49-.22-.3-.66-.38a10.62,10.62,0,0,0-1.81-.12A10.75,10.75,0,0,0,15,51.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M25.29,48.94a4,4,0,0,1-1.94.61V47.7A2.26,2.26,0,0,0,24.71,47a4,4,0,0,0,.95-1.54A6.24,6.24,0,0,0,26,43.4l2,.12a7,7,0,0,1-.39,2.35l2.82,2.22-1.22,1.36-2.38-2A5.4,5.4,0,0,1,25.29,48.94Zm8,2.7v1.78H24.15V49.89h2v1.75Zm-2.13-5.15H29.34V44.66h1.82v-1.3h2v7.45h-2Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M38,43.59h1.82V53H35.24V43.59h1.81v3H38Zm0,7.56V48.34h-.94v2.81Zm7.08-7.79V53.42H43.21V48.94h-.84v4.3H40.54V43.4h1.83v3.66h.84v-3.7Z"
})));

function SvgWhiteshape(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.07 53.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteshape);
export default __webpack_public_path__ + "static/media/whiteshape.f8edf92e.svg";
export { ForwardRef as ReactComponent };